/**
 * Configuração do login entregue pelo monitor em tempo de execução
 * (`/config.js`, ver `packages/monitor/src/http/runtime_config.ts`).
 *
 * Puro — recebe o objeto em vez de ler `window` —, para poder ser testado. A
 * fiação fica em `src/auth/config.ts`.
 */

export interface RuntimeConfig {
  googleClientId: string;
  /** Nulo quando o monitor não mandou a lista (script não carregou). */
  allowedEmails: string[] | null;
}

/**
 * Lê `window.__SICOP_CONFIG__` com desconfiança: o script pode não ter
 * carregado (monitor fora do ar, dev server sem proxy), e o que vier errado
 * vira "não configurado" — botão de login desabilitado —, nunca uma exceção
 * que derrube a tela.
 */
export function readRuntimeConfig(source: unknown): RuntimeConfig {
  const config = (source ?? {}) as { googleClientId?: unknown; allowedEmails?: unknown };

  const googleClientId = typeof config.googleClientId === 'string' ? config.googleClientId.trim() : '';
  const allowedEmails = Array.isArray(config.allowedEmails)
    ? config.allowedEmails
        .filter((email): email is string => typeof email === 'string')
        .map((email) => email.trim().toLowerCase())
        .filter(Boolean)
    : null;

  return { googleClientId, allowedEmails };
}
